module.exports = __webpack_public_path__ + "img/align-vertical-center-01.36325ce0.svg";